import { scales } from './tokens.js'

/**
 * Shell metrics as numbers, for the handful of places that need them in JS
 * rather than CSS: the Sider's `width` and `collapsedWidth` props, the fixed
 * header's offset, and the spacer that reserves the sidebar's column.
 *
 * These mirror `--sidebar-width`, `--header-height` and friends, so the profile
 * stays the only place a shell dimension is written down.
 */
const toPx = (value) => Number.parseInt(value, 10)

export const LAYOUT = {
  headerHeight: toPx(scales.layout.headerHeight),
  sidebarWidth: toPx(scales.layout.sidebarWidth),
  sidebarWidthCollapsed: toPx(scales.layout.sidebarWidthCollapsed),
  sidebarWidthMobile: toPx(scales.layout.sidebarWidthMobile),
  tableRowHeight: toPx(scales.layout.tableRowHeight),
  pagePadding: scales.layout.pagePadding,
  contentMaxWidth: scales.layout.contentMaxWidth,
  sectionGap: scales.layout.sectionGap,
}

export default LAYOUT
